import React, { createContext, useState, useEffect, useContext } from 'react';
import { jwtDecode } from 'jwt-decode'; // Correct import

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  // WEST-794: true when the signed-in user has no email on file and must add one before
  // doing anything else. Set from the login response, cleared when the profile is saved.
  const [emailRequired, setEmailRequiredState] = useState(() => {
    try { return localStorage.getItem('email_required') === 'true'; } catch (e) { return false; }
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      validateToken(token);
    }
  }, []);

  const validateToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Current time in seconds
      if (decoded.exp && decoded.exp > currentTime) {
        setUser(decoded); // Token is valid
      } else {
        logout(); // Token is expired
      }
    } catch (error) {
      console.error('Error decoding token:', error.message);
      logout();
    }
  };

  const setEmailRequired = (required) => {
    localStorage.setItem('email_required', required ? 'true' : 'false');
    setEmailRequiredState(Boolean(required));
  };

  const login = (token, emailRequiredFlag = false) => {
    localStorage.setItem('token', token);

    // Decode and store relevant claims
    const decoded = jwtDecode(token);
    setUser(decoded);
    setEmailRequired(emailRequiredFlag);

    // Optional: store specific claims locally
    localStorage.setItem('role_name', decoded.role_name);
    localStorage.setItem('active', decoded.active);
    localStorage.setItem('id', decoded.id);
    localStorage.setItem('customer_id', decoded.customer_id);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role_name');
    localStorage.removeItem('active');
    localStorage.removeItem('id');
    localStorage.removeItem('customer_id');
    localStorage.removeItem('email_required');
    setUser(null);
    setEmailRequiredState(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, emailRequired, setEmailRequired, getClaimFromUser: (claim) => user?.[claim] }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthContext;
